export default __webpack_public_path__ + "static/media/jobbet-logo-vit.238c42d5.png";